module.exports = __webpack_public_path__ + "static/media/smiling-face-with-sunglasses_1f60e.49742d6a.png";